export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/td.40dfdf1e.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};